import { ERROR, SUCCESS } from "../constants/types/alertType";
import {
  CLEAR_UNFINALIZED_PRESCRIPTION,
  CLEAR_HISTORY_PRESCRIPTION,
  NEW_PRESCRIPTION_RECEIVED,
  ORDERED_PRESCRIPTION_RECEIVED,
  PRACTITIONER_HISTORY_PRESCRIPTION_RECEIVED,
  PRACTITIONER_PRESCRIPTION_HISTORY_RECEIVED,
  PRACTITIONER_UNFINALIZED_PRESCRIPTION_RECEIVED,
  PRESCRIPTION_HISTORY_RECEIVED,
  PRESCRIPTION_PAGE_TAB_SHOW_ITEM_LIST,
  REFILL_REQUEST_RECEIVED,
  UNFINALIZED_PRESCRIPTIONI_ID_RECEIVED,
  UNORDERED_PRESCRIPTION_RECEIVED,
} from "../constants/types/prescriptionType";
import axios from "../utils/axios";
import { appLoading } from "./alertAction";

export const clearUnfinalizedPrescription = () => (dispatch) => {
  dispatch({
    type: CLEAR_UNFINALIZED_PRESCRIPTION,
    payload: null,
  });
};

export const clearHistorydPrescription = () => (dispatch) => {
  dispatch({
    type: CLEAR_HISTORY_PRESCRIPTION,
    payload: null,
  });
};

export const prescriptionPageTabShowItemList = (items) => (dispatch) => {
  dispatch({
    type: PRESCRIPTION_PAGE_TAB_SHOW_ITEM_LIST,
    payload: items,
  });
};
export const getNewPrescriptionList = () => (dispatch) => {
  axios.get("prescriptionsPatient?action=getUnOrdered").then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: NEW_PRESCRIPTION_RECEIVED,
          payload: resp.data.prescriptionList,
        });
      } else {
        dispatch({
          type: NEW_PRESCRIPTION_RECEIVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const setUnfinalizedPrescriptionId = (id) => (dispatch) => {
  dispatch({
    type: UNFINALIZED_PRESCRIPTIONI_ID_RECEIVED,
    payload: id,
  });
};

export const getRefillRequests = () => (dispatch) => {
  axios.get("prescriptionsPractitioner?action=getRefills").then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: REFILL_REQUEST_RECEIVED,
          payload: resp.data.prescriptionList,
        });
      } else {
        dispatch({
          type: REFILL_REQUEST_RECEIVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const getPresciptionHistory = (callback) => (dispatch) => {
  axios.get("prescriptionsPatient?action=getHistory").then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: PRESCRIPTION_HISTORY_RECEIVED,
          payload: resp.data.prescriptionList,
        });
      } else {
        dispatch({
          type: PRESCRIPTION_HISTORY_RECEIVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      callback && callback();
    }
  );
};

export const addPatientFeedback = (id, feedback, callback) => (dispatch) => {
  axios
    .get(
      `feedback?action=saveEditPatientFeedback&notes=${feedback}&prescription_id=${id}`
    )
    .then(
      (resp) => {
        if (resp.data) {
          dispatch({
            type: SUCCESS,
            payload: resp.data.message,
          });
          callback && callback();
        } else {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
        }
      },
      (err) => {
        dispatch({
          type: ERROR,
          payload: "Failed to complete action",
        });
      }
    );
};

export const addPractitionerNote = (id, note, callback) => (dispatch) => {
  axios
    .get(
      `notes?action=saveEditPractitionerNotes&notes=${note}&prescription_id=${id}`
    )
    .then(
      (resp) => {
        if (resp.data) {
          dispatch({
            type: SUCCESS,
            payload: resp.data.message,
          });
          callback && callback();
        } else {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
        }
      },
      (err) => {
        dispatch({
          type: ERROR,
          payload: "Failed to complete action",
        });
      }
    );
};

export const getPractitionerPresciptionHistory = (callback) => (dispatch) => {
  axios.get("prescriptionsPractitioner?action=getHistory").then(
    (resp) => {
      if (resp.data?.result == "success") {
        dispatch({
          type: PRACTITIONER_PRESCRIPTION_HISTORY_RECEIVED,
          payload: resp.data.prescriptionList,
        });
      } else {
        dispatch({
          type: PRACTITIONER_PRESCRIPTION_HISTORY_RECEIVED,
          payload: [],
        });
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
      callback && callback();
    },
    (err) => {
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      callback && callback();
    }
  );
};

export const getOrderedPrescription =
  (prescription_id, callback) => (dispatch) => {
    axios
      .get(
        `prescriptionsPatient?action=getOrderedPrescription&prescription_id=${prescription_id}`
      )
      .then(
        (resp) => {
          if (resp.data) {
            if (resp.data?.error) {
              dispatch({
                type: ERROR,
                payload: resp.data?.error,
              });
            } else {
              dispatch({
                type: ORDERED_PRESCRIPTION_RECEIVED,
                payload: resp.data,
              });
              callback && callback();
            }
          } else {
            dispatch({
              type: ORDERED_PRESCRIPTION_RECEIVED,
              payload: [],
            });
            callback && callback();
          }
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
          callback && callback();
        }
      );
  };
export const getUnOrderedPrescription =
  (prescription_id, callback) => (dispatch) => {
    axios
      .get(
        `prescriptionsPatient?action=getUnOrderedPrescription&prescription_id=${prescription_id}`
      )
      .then(
        (resp) => {
          if (resp.data) {
            dispatch({
              type: UNORDERED_PRESCRIPTION_RECEIVED,
              payload: resp.data,
            });
            callback && callback(resp.data);
          } else {
            dispatch({
              type: UNORDERED_PRESCRIPTION_RECEIVED,
              payload: [],
            });
            callback && callback();
          }
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
          callback && callback();
        }
      );
  };

export const refillPrescription = (data, callback) => (dispatch) => {
  axios.post("prescriptionsPatient", data).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
    }
  );
};

export const getHistoryPrescriptionForPractitioner =
  (prescription_id, callback) => (dispatch) => {
    axios
      .get(
        `prescriptionsPractitioner?action=getHistoryPrescription&prescription_id=${prescription_id}`
      )
      .then(
        (resp) => {
          if (resp.data) {
            if (resp.data?.error) {
              dispatch({
                type: ERROR,
                payload: resp.data?.error,
              });
            } else {
              dispatch({
                type: PRACTITIONER_HISTORY_PRESCRIPTION_RECEIVED,
                payload: resp.data,
              });
            }
          } else {
            dispatch({
              type: PRACTITIONER_HISTORY_PRESCRIPTION_RECEIVED,
              payload: [],
            });
          }
          callback && callback();
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
          callback && callback();
        }
      );
  };

export const getUnfinalizedPrescription =
  (prescription_id, callback) => (dispatch) => {
    axios
      .get(
        `prescriptionsPractitioner?action=getUnfinalizedPrescription&prescription_id=${prescription_id}`
      )
      .then(
        (resp) => {
          if (resp.data) {
            dispatch({
              type: PRACTITIONER_UNFINALIZED_PRESCRIPTION_RECEIVED,
              payload: resp.data,
            });
            callback && callback(resp?.data);
          } else {
            dispatch({
              type: PRACTITIONER_UNFINALIZED_PRESCRIPTION_RECEIVED,
              payload: [],
            });
            callback && callback();
          }
        },
        (err) => {
          dispatch({
            type: ERROR,
            payload: "Failed to complete action",
          });
          callback && callback();
        }
      );
  };

export const practitonerPrescriptionPostAction =
  (data, callback) => (dispatch) => {
    dispatch(appLoading(true));
    axios.post("prescriptionsPractitioner", data).then(
      (resp) => {
        if (resp.data.result === "success" || resp.status === 200) {
          if (callback) {
            if (resp?.data?.rx_id) {
              callback(resp.data.rx_id);
            } else {
              if (data.params.action == "sendPatientPrescription") {
                if (resp.data.result === "failed") {
                  dispatch(appLoading(false));
                  dispatch({
                    type: ERROR,
                    payload: resp.data.error,
                  });
                  return;
                }
              }
              callback();
            }
          }

          if (resp.data?.message) {
            dispatch({
              type: SUCCESS,
              payload: resp.data.message,
            });
          }
          if (resp.data?.error) {
            dispatch({
              type: ERROR,
              payload: resp.data.error,
            });
          }
        } else {
          dispatch({
            type: ERROR,
            payload: resp.data.error,
          });
        }
        dispatch(appLoading(false));
      },
      (err) => {
        console.log(err);
        dispatch({
          type: ERROR,
          payload: "Failed to complete action",
        });
        dispatch(appLoading(false));
      }
    );
  };
export const practitonerOrderPostAction = (data, callback) => (dispatch) => {
  dispatch(appLoading(true));
  axios.post("ordersPractitioner", data).then(
    (resp) => {
      if (resp.data.result === "success") {
        callback && callback();
        dispatch({
          type: SUCCESS,
          payload: resp.data.message,
        });
      } else {
        dispatch({
          type: ERROR,
          payload: resp.data.error,
        });
      }
      dispatch(appLoading(false));
    },
    (err) => {
      console.log(err);
      dispatch({
        type: ERROR,
        payload: "Failed to complete action",
      });
      dispatch(appLoading(false));
    }
  );
};
